// extracted by mini-css-extract-plugin
export var confirmationHeader = "_wz-0";
export var confirmationIcon = "_wz-1";